import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ROLES, ROUTES, WARNINGS } from "../Common/Constants";
import { redirectToRelatedPage } from "../Common/Utils";
import { useOrganization } from "../../OrganizationProvider";
import jwtDecode from "jwt-decode";
import Iframe from "../Common/Grafana/Iframe";
import { grafanaBaseUrl } from "../Common/endpoints";
import Loader from "../Common/Loader";

const Dashboard = () => {
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const organization = useOrganization();
  const decodedJwt = localStorage.getItem("authToken")
    ? jwtDecode(localStorage.getItem("authToken"))
    : "";

  useEffect(() => {
    document.title =
      userDetails?.currentOrganisation?.name || organization?.name;
    if (userDetails?.currentOrgRole === ROLES.RIDER) {
      navigate(ROUTES.LOGOUT.link);
      toast.warning(WARNINGS.RIDER_LOGIN);
    } else {
      setTimeout(function () {
        navigate(redirectToRelatedPage());
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Loader text="Enabling Charts..." />
      {decodedJwt !== "" && (
        <Iframe
          title="Login"
          src={`${grafanaBaseUrl}/login?token=${authToken}`}
          width="0"
          height="0"
        />
      )}
    </>
  );
};

export default Dashboard;
